import styles from './index.module.scss';
import { Link } from 'react-router-dom';
import { Image, Toast } from 'antd-mobile';
import backIcon from '../../assets/icon/arrow.png';
import qrcode1 from '../../assets/image/qrcode1.jpg';
import qrcode2 from '../../assets/image/qrcode2.jpg';
import qrcode3 from '../../assets/image/qrcode3.jpg';
import { observer } from 'mobx-react-lite';
import { QRCodeManager } from '../../objects/qrcode/manager';
import { useEffect, useState } from 'react';
import { OrderShortType } from '../../types';

const Group = observer(() => {
  const [manager] = useState(() => new QRCodeManager());
  const handleImageClick = (index: number) => {
    Toast.show({
      content: `已选择二维码${index + 1}，请长按保存或直接扫码`,
      position: 'top',
    });
  };

  useEffect(() => {
    manager.setFetchAll(true);
    manager.setSorter('sort_num');
    manager.setOrder(OrderShortType.Descend);
    manager.setFilters({ show: [true] });
    manager.list();
  }, [manager]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/">
          <img src={backIcon} alt="返回" />
        </Link>
        <p>加入我们的社群</p>
      </div>

      <div className={styles.content}>
        <h2 className={styles.title}>欢迎加入我们的社群</h2>
        <div className={styles.steps}>
          <p>1. 选择下方任意一个二维码</p>
          <p>2. 长按保存图片或直接扫码</p>
          <p>3. 添加管理员为好友</p>
          <p>4. 发送"加入群聊"给管理员</p>
          <p>5. 等待管理员邀请您入群</p>
        </div>

        <div className={styles.tip}>
          <p>温馨提示：</p>
          <p>• 如果某个二维码无法添加，请尝试其他二维码</p>
          <p>• 每个管理员处理请求可能需要一些时间，请耐心等待</p>
          <p>• 入群后请遵守群规，友善交流</p>
        </div>

        <div className={styles.qrcodeContainer}>
          {manager.data.map((item, index) => {
            return (
              <div key={index} className={styles.qrcodeItem}>
                <p>管理员{index + 1}</p>
                <Image
                  src={item.url}
                  // onClick={() => handleImageClick(2)}
                  className={styles.qrcodeImage}
                />
              </div>
            );
          })}

          {/* <div className={styles.qrcodeItem}>
            <p>管理员{}</p>
            <Image
              src={qrcode1}
              onClick={() => handleImageClick(0)}
              className={styles.qrcodeImage}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
});

export default Group;
